import { profileSchema, type Profile } from '@secretario/shared';

/**
 * O último perfil (personagem, nome, roupa) fica guardado no aparelho para a Início
 * desenhar no primeiro quadro, sem esperar o servidor; a resposta dele só corrige
 * o que mudou. Preso à conta: outra pessoa entrando no mesmo aparelho não vê nada.
 */
const KEY = 'secretario.perfil';

export function readCachedProfile(userId: string | undefined): Profile | null {
  if (!userId) return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const stored = JSON.parse(raw) as { userId?: string; profile?: unknown };
    if (stored.userId !== userId) return null;
    const parsed = profileSchema.safeParse(stored.profile);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function writeCachedProfile(userId: string | undefined, profile: Profile): void {
  if (!userId) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ userId, profile, at: Date.now() }));
  } catch {
    /* sem armazenamento: a próxima abertura espera o servidor */
  }
}

export function clearCachedProfile(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* nada guardado */
  }
}
